import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { VIEW_MODE } from '../../constants/app-permissions';
import { Option } from '../../models/option.model';
import { TranslocoPipe } from '@jsverse/transloco';
import { ActionList } from '../../models/action-list.model';
import { ActionListComponent } from '../action-list/action-list.component';
import { TrimTooltipDirective } from '../../../../ui-components/directives/trim-tooltip/trim-tooltip.directive';
import { AvatarPipe } from '../../../../ui-components/pipes/avatar/avatar.pipe';
import { NoUserDataIconComponent } from '@kuiper/icons';

@Component({
  selector: 'lib-group-user-card',
  imports: [
    AvatarPipe,
    TranslocoPipe,
    ActionListComponent,
    TrimTooltipDirective,
    NoUserDataIconComponent,
  ],
  templateUrl: './group-user-card.component.html',
  styleUrl: './group-user-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class GroupUserCardComponent {
  readonly VIEW_MODE = VIEW_MODE;
  list = input<Option[]>([]);
  itemType = input.required<'User' | 'Group'>();
  mode = input.required<'view' | 'edit'>();
  unselectGroupUser = output<Option>();
  actionListItemClickEmitter = output<any>();
  actionList = input<ActionList[]>([]);

  removeGroupUser(user: Option) {
    if (this.mode() === 'edit') {
      this.unselectGroupUser.emit(user);
    }
  }

  actionListItemClick(action: string, item: Option) {
    this.actionListItemClickEmitter.emit({ action, item });
  }
}
